<template>
  <hr class="ui-dropdown-divider" />
</template>

<style scoped lang="scss">
.ui-dropdown-divider {
  margin: 4px 8px;
}
</style>
